module.exports = __webpack_public_path__ + "static/media/IMG_4825.4d33fc91.JPG";